import { mappingRptConstants } from '../constants';

export function mappingRpt(state = {}, action) {
    switch (action.type) {
        case mappingRptConstants.LOADING_REQUEST:
            return {
                ...state,
                loding: action.isbool
            };
        case mappingRptConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case mappingRptConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case mappingRptConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case mappingRptConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case mappingRptConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case mappingRptConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }

}